// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"3ed712a3","38":"dcc8b056","236":"564059d7","447":"3ed712a3","729":"3ed712a3","761":"3ed712a3","793":"3ed712a3"}[chunkId] + ".chunk.css";
};